import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { IMAGE_TOGGLE, ImageToggleOptions } from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

import { getRenderElement } from '../../../../slatePlugins/common/utils/getRenderElement';
import { setDefaults } from '../../../../slatePlugins/common/utils/setDefaults';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const ReadOnlyImageToggleElement = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import('./ReadOnlyImageToggleElement').then((mod) => mod.ReadOnlyImageToggleElement)
  )
);

export const renderElementImageToggle = (options?: any) => {
  const { imageToggle } = setDefaults(options, {
    imageToggle: {
      type: IMAGE_TOGGLE,
      component: ReadOnlyImageToggleElement,
    },
  });

  return getRenderElement(imageToggle);
};

export const ImageToggleReadOnlyPlugin = (options?: ImageToggleOptions): SlatePlugin => ({
  renderElement: renderElementImageToggle(options),
  voidTypes: [IMAGE_TOGGLE],
});
